<template>
  <div class="home">
    <div class="header">
      <div class="notice">
        <div class="notice-inner">
          <div class="marquee-container">
            <span :style="{ 'animation-duration': remindText.length + 's' }">{{
              remindText
            }}</span>
          </div>
        </div>
      </div>
      <div class="logo">
        <img src="../assets/logodima.png" alt="" />
      </div>
      <div class="datetime">{{ currentTime }}</div>
    </div>
    <div class="main">
      <div class="main-left">
        <div class="main-left-top">
          <div class="main-left-top-left">
            <div class="chart-act block">
              <div class="block-header">
                <span>机构活动</span>
                <!-- <span>截至：{{ getYesterday }}</span> -->
                <!--                <span>截至：{{ getYesterday }}</span>-->
              </div>
              <div class="block-content">
                <div class="chart-container">
                  <div id="highchart-act"></div>
                </div>
                <div class="act-sort" v-if="chartInfo">
                  <div class="act-sort-title">最受欢迎TOP10</div>
                  <ul>
                    <li
                      v-for="item in getChartInfo('BI_ACTIVITY_TOP').dataList"
                      :key="item.dataId"
                    >
                      <span>{{ item.dataSubCodeName }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="chart-monit block">
              <div class="block-header">
                <span>机构展示</span>
                <!--                <span>{{ monitorTime }}</span>-->
              </div>
              <div class="block-content">
                <!-- <div class="fourimg" style="width: 100%; height: 100%">
                  <div class="fourItem"
                    v-for="item in monitorRes"
                    :key="item.attachId"
                  >
                    <img
                      class="itemPic"
                      :src="`/ophApi/commonAttachDown/download?id=${item.attachId}`"
                      alt=""
                    />
                    <p class="itemP">{{ item.position}}</p>
                  </div>
                </div> -->
                <swiper
                  style="width: 100%; height: 100%"
                  :options="swiperOption1"
                  @slideChangeTransitionEnd="onSlideChange"
                >
                  <swiper-slide
                    style="width: 100%; height: 100%"
                    v-for="item in monitorRes"
                    :key="item.attachId"
                  >
                    <div class="fourimg" style="width: 100%; height: 100%">
                      <div class="fourItem"
                        v-for="item1 in item"
                        :key="item1.attachId"
                      >
                        <img
                          class="itemPic"
                          :src="`/ophApi/commonAttachDown/download?id=${item1.attachId}`"
                          alt=""
                        />
                        <p class="itemP">{{ item1.position}}</p>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
            <div class="chart-specialist block">
              <div class="block-header">
                <span>专家团队</span>
              </div>
              <div class="block-content" v-if="staffList">
                <swiper class="swiper" :auto-update="true">
                  <swiper-slide
                    style="background-color: #fff0"
                    v-for="(item, i) in new Array(
                      Math.ceil(staffList.length / 2)
                    ).fill(1)"
                    :key="i"
                  >
                    <ul>
                      <li
                        v-for="staff in staffList.slice(i * 2, i * 2 + 2)"
                        :key="staff.id"
                      >
                        <div class="avatar">
                          <img
                            :src="`/ophApi/commonAttachDown/download?id=${staff.avatarId}`"
                            alt=""
                          />
                          <div>{{ staff.staffName }}</div>
                        </div>
                        <div class="dscp">{{ staff.staffIntroduce }}</div>
                      </li>
                    </ul>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
          <div class="main-left-top-right">
            <div class="overview" v-if="homeInfo">
              <h4>项目概况</h4>
              <div class="nums">
                <ul>
                  <li>
                    <span>{{ biFirstScreenType['BI_FIRST_SCREEN_BRANCH_COUNT'] }}</span>
                    <h2>{{ homeInfo.branchCount }}</h2>
                  </li>
                  <li>
                    <span>{{ biFirstScreenType['BI_FIRST_SCREEN_BEDS'] }}</span>
                    <h2>{{ homeInfo.beds }}</h2>
                  </li>
                  <li>
                    <span>{{ biFirstScreenType['BI_FIRST_SCREEN_INTO_ELDERS'] }}</span>
                    <h2>{{ homeInfo.intoElders }}</h2>
                  </li>
                  <li>
                    <span>入住率</span>
                    <h2>{{ homeInfo.occupancyRate }}%</h2>
                  </li>
                </ul>
              </div>
            </div>
            <div class="map-container" v-if="orgInfo">
              <div
                class="area sichuan"
                @mouseover="activeArea = 'sichuan'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('sichuan', 1)"
                :class="{ active: activeArea === 'sichuan' }"
              ></div>
              <div
                class="area chongqing"
                @mouseover="activeArea = 'chongqing'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('chongqing', 0)"
                :class="{ active: activeArea === 'chongqing' }"
              ></div>
              <div
                class="area shanghai"
                @mouseover="activeArea = 'shanghai'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('shanghai', 2)"
                :class="{ active: activeArea === 'shanghai' }"
              >
                <div class="holoes">
                  <div class="holo"></div>
                  <div class="holo"></div>
                  <div class="holo"></div>
                </div>
              </div>
              <div
                class="light sichuan"
                @mouseover="activeArea = 'sichuan'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('sichuan', 1)"
              ></div>
              <div
                class="light chongqing"
                @mouseover="activeArea = 'chongqing'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('chongqing', 0)"
              ></div>
              <div
                class="light shanghai"
                @mouseover="activeArea = 'shanghai'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('shanghai', 2)"
              ></div>
              <div
                class="info-box sichuan"
                @mouseover="activeArea = 'sichuan'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('sichuan', 1)"
              >
                <h3>
                  四川&nbsp;({{
                    orgInfo.sichuan ? orgInfo.sichuan.branchCount : 0
                  }}家)
                </h3>
                <span
                  >入住率&nbsp;{{
                    orgInfo.sichuan ? orgInfo.sichuan.occupancyRate : 0
                  }}%</span
                >
              </div>
              <div
                class="info-box chongqing"
                @mouseover="activeArea = 'chongqing'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('chongqing', 0)"
              >
                <h3>重庆&nbsp;({{ orgInfo.chongqing.branchCount }}家)</h3>
                <span>入住率&nbsp;{{ orgInfo.chongqing.occupancyRate }}%</span>
              </div>
              <!-- <div
                class="info-box shanghai"
                @mouseover="activeArea = 'shanghai'"
                @mouseout="activeArea = ''"
                @click="goOrgPage('shanghai', 2)"
              >
                <h3>上海&nbsp;(筹建中)</h3>
              </div> -->
              <!-- <star></star> -->
              <city-path></city-path>
            </div>
            <!-- <div class="chart-checkin block">
              <div class="block-header">
                <span>入住趋势（本周新增入住：{{getChartInfo('INTO_ELDERS').dataSum}}人）</span>
              </div>
              <div class="block-content">
                <div id="highchart-checkin"></div>
              </div>
            </div>
            <div class="chart-checkin-top block">
              <div class="block-header">
                <span>入住率TOP10</span>
                <span>截至：{{getYesterday}}</span>
              </div>
              <div class="block-content">
                <div id="highchart-checkin-top"></div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="main-left-bottom">
          <div class="main-left-bottom-left">
            <div class="chart-meal block">
              <div class="block-header">
                <span>机构饮食</span>
                <!-- <span>截至：{{ getYesterday }}</span> -->
                <!--                <span>截至：{{ getYesterday }}</span>-->
              </div>
              <div class="block-content">
                <div id="highchart-meal"></div>
                <div id="highchart-meal-bar"></div>
              </div>
            </div>
          </div>
          <div class="main-left-bottom-center">
            <div class="chart-gender block">
              <div class="block-header">
                <span>性别分布</span>
                <!-- <span>截至：{{ getYesterday }}</span> -->
                <!--                <span>截至：{{ getYesterday }}</span>-->
              </div>
              <div class="block-content">
                <div id="highchart-gender"></div>
              </div>
            </div>
          </div>
          <div class="main-left-bottom-right">
            <div class="chart-age block">
              <div class="block-header">
                <span>入住年龄分布</span>
                <!-- <span>截至：{{ getYesterday }}</span> -->
                <!--                <span>截至：{{ getYesterday }}</span>-->
              </div>
              <div class="block-content">
                <div id="highchart-age"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-righthoho">
        <div class="chart-checkin block">
          <!-- <div class="block-header">
            <span>入住趋势（本周新增入住：{{getChartInfo('INTO_ELDERS').dataSum}}人）</span>
          </div> -->
          <!-- <div class="block-content">
            <div id="highchart-checkin"></div>
          </div> -->
          <div class="block-header">
            <!-- <span>入住率TOP10</span> -->
            <!-- <span>机构床位均价(元)</span> -->
            <span>入住率</span>
            <!-- <span>截至：{{getYesterday}}</span> -->
          </div>
          <div class="block-content">
            <div id="highchart-checkin-top"></div>
          </div>
        </div>
        <div class="chart-disease block">
          <!-- <div class="block-header">
            <span>入住长者慢性病占比</span>
            <span>截至：{{getYesterday}}</span>
          </div>
          <div class="block-content" style="height: 280px;">
            <div id="highchart-disease"></div>
          </div> -->
          <div class="block-header">
            <span>慢性病TOP5</span>
            <!-- <span>截至：{{ getYesterday }}</span> -->
            <!--            <span>截至：{{ getYesterday }}</span>-->
          </div>
          <div class="block-content" style="height: 200px">
            <div id="highchart-disease-bar"></div>
          </div>
        </div>
        <div class="chart-nurse block">
          <div class="block-header">
            <span>护理等级分布</span>
            <!-- <span>截至：{{ getYesterday }}</span> -->
            <!--            <span>截至：{{ getYesterday }}</span>-->
          </div>
          <div class="block-content">
            <div id="highchart-nurse"></div>
          </div>
        </div>
      </div>
    </div>
    <m-dialog
      :show.sync="monitorShow"
      :no-head="true"
      @open="monitorOpen"
      @close="monitorClose"
      :append-to-body="true"
      width="1000px"
    >
      <video id="monitor-modal" controls></video>
    </m-dialog>
  </div>
</template>
<script>
import Hls from 'hls.js'
import moment from 'moment'
import Highcharts from 'highcharts'
import Highcharts3d from 'highcharts/highcharts-3d'
import actChartOpts from '@/charts/act.js'
import mealChartOpts from '@/charts/meal-donut.js'
import mealBarChartOpts from '@/charts/meal-bar.js'
import genderChartOpts from '@/charts/gender.js'
import ageChartOpts from '@/charts/age.js'
// import diseaseChartOpts from '@/charts/disease.js'
import diseaseBarChartOpts from '@/charts/disease-bar.js'
import nurseChartOpts from '@/charts/nurse.js'
import checkinChartOpts from '@/charts/checkin.js'
import checkinTopChartOpts from '@/charts/checkin-top.js'

// import Star from '../components/star'
import CityPath from '../components/city-path'

// 监控轮播时长
const MONITOR_SLIDE_INTERVAL = 1000 * 60

Highcharts3d(Highcharts)

export default {
  name: 'Home',
  components: { CityPath },
  data () {
    return {
      monitorShow: false,
      activeArea: '',
      player1: null,
      player2: null,
      $videoModal: null,

      currentTime: '',
      monitorTime: '',
      timer: null,

      homeInfo: null,
      chartInfo: null,
      orgInfo: null,
      staffList: null,

      // 跑马灯文字
      remindText: '',
      monitorList: [], // 监控列表
      hlsModalSrc: '', // 弹窗监控地址
      monitorRes: [],
      swiperOption1: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 9000
        }
      },
      biFirstScreenType: {
        BI_FIRST_SCREEN_BRANCH_COUNT: '机构数(家)',
        BI_FIRST_SCREEN_BEDS: '总床位(床)',
        BI_FIRST_SCREEN_INTO_ELDERS: '在住床数(床)'
      }
    }
  },
  created () {
    console.log(this.returnFloat(14.01))
  },
  async mounted () {
    // 右上角时间
    this.startTimer()

    await this.getBiFirstScreenType()

    /* const formData = new FormData()
    const req = {
      saasId: 1000,
      username: '13900000000',
      password: '000000',
      loginTenantId: 1000,
      needMenu: true
    }
    for (const key in req) {
      formData.append(key, req[key])
    }
    const loginRes = await this.$http.post('/auth/login', formData)
    console.log(loginRes.data) */

    const { data: res } = await this.$http.post('/biDataDaily/typeBeanList', {
      initZero: true
    })
    this.chartInfo = res.data
    const { data: orgRes } = await this.$http.get('/biDataDaily/operateInfo')
    // this.orgInfo = orgRes.data
    this.orgInfo = {
      chongqing: orgRes.data.children[0],
      sichuan: orgRes.data.children[1],
      shanghai: orgRes.data.children[2]
    }
    localStorage.homeInfos = JSON.stringify(orgRes.data.children)
    this.homeInfo = orgRes.data
    Highcharts.chart(
      'highchart-act',
      actChartOpts(this.getChartInfo('BI_ACTIVITY_DIS'))
    )
    Highcharts.chart(
      'highchart-meal',
      mealChartOpts(this.getChartInfo('BI_MEALS_DST'))
    )
    Highcharts.chart(
      'highchart-meal-bar',
      mealBarChartOpts(this.getChartInfo('BI_DISH_TOP'))
    )
    Highcharts.chart(
      'highchart-gender',
      genderChartOpts(orgRes.data.male, orgRes.data.female)
    )
    Highcharts.chart(
      'highchart-age',
      ageChartOpts(this.getChartInfo('BI_AGE_DIS'))
    )
    // Highcharts.chart('highchart-disease', diseaseChartOpts(this.getChartInfo('BI_CD_DIS')))
    // Highcharts.chart('highchart-disease', diseaseChartOpts(this.getChartInfo('BI_CD_TOP')))
    Highcharts.chart(
      'highchart-disease-bar',
      diseaseBarChartOpts(this.getChartInfo('BI_CD_TOP'))
    )
    Highcharts.chart(
      'highchart-nurse',
      nurseChartOpts(this.getChartInfo('BI_NURSE_LV_DIS'))
    )
    // Highcharts.chart('highchart-checkin', checkinChartOpts(this.getChartInfo('INTO_ELDERS')))
    // Highcharts.chart('highchart-checkin-top', checkinTopChartOpts(orgRes.data.occupancyTop10))
    const avgBedArr = this.orgInfo.sichuan.children.concat(this.orgInfo.chongqing.children)
    Highcharts.chart(
      'highchart-checkin-top',
      checkinTopChartOpts(avgBedArr)
    )

    const { data: staffRes } = await this.$http.get(
      '/biServiceStaff/listBeans'
    )
    this.staffList = staffRes.data.find(
      (item) => item.staffType === 'SERVICE_EXPERT'
    ).staffList

    // 左上角跑马灯
    const formData = new FormData()
    formData.append('codeTypeId', 997)
    const { data: remindRes } = await this.$http.post(
      '/comn/codeValue/list',
      formData
    )
    // console.log(remindRes)
    if (remindRes.data.rows.length > 0) {
      this.remindText = remindRes.data.rows[0].nameCn
    }
    // 监控列表
    const { data: monitorRes } = await this.$http.get(
      '/surveillancelist/SurveillancelistInfo'
    )
    // this.monitorRes = monitorRes.data;
    // this.monitorRes = monitorRes.data.slice(0,4);
    this.monitorRes = this.arrTrans(4, monitorRes.data)
    console.log(this.monitorRes, 'monitorRes')

    // console.log(monitorRes,'monitorRes');
    // const monitorGroupCount = Math.ceil(monitorRes.data.length / 4);
    // const monitorGroups = [];
    // for (let i = 0; i < monitorGroupCount; i++) {
    //   if (i < monitorGroupCount - 1) {
    //     monitorGroups.push(monitorRes.data.slice(i * 4, i * 4 + 4));
    //   } else {
    //     monitorGroups.push(
    //       monitorRes.data.slice(i * 4, monitorRes.data.length + 1)
    //     );
    //   }
    // }
    // this.monitorList = monitorGroups;
    // console.log(monitorGroups, "monitorGroups");
    // this.$nextTick(() => {
    //   this.playMonitorGroup(0);
    //   this.monitorSwiperChanged();
    // });
  },
  methods: {
    onSlideChange ($swiper) {
      // console.log($swiper.activeIndex);
    },
    arrTrans (num, arr) { // 一维数组转换为二维数组
      const iconsArr = [] // 声明数组
      arr.forEach((item, index) => {
        const page = Math.floor(index / num) // 计算该元素为第几个素组内
        if (!iconsArr[page]) { // 判断是否存在
          iconsArr[page] = []
        }
        iconsArr[page].push(item)
      })
      return iconsArr
    },
    returnFloat (num) {
      num = num.toString()
      if (num.indexOf('.') != -1) {
        let newVal = num.split('.')
        if (newVal[1].length == 1) {
          newVal = newVal.join('.')
          newVal += '0'
          num = newVal
        }
      } else {
        num += '.00'
      }

      return num
    },
    playMonitorGroup (i) {
      console.log(`start load monitor group  ${i}`)
      this.monitorList[i].forEach((monitor, j) => {
        if (monitor.player) {
          this.$el.querySelector(`#monitor-${i}-${j}`).play()
        } else {
          const hlsSrc = monitor.url
          const $video = this.$el.querySelector(`#monitor-${i}-${j}`)
          monitor.player = this.loadHls($video, hlsSrc)
          monitor.player.on(Hls.Events.MANIFEST_PARSED, () => {
            $video.play()
          })
        }
      })
    },
    pauseMonitorGroup (i) {
      console.log(`pause monitor group ${i}`)
      this.monitorList[i].forEach((monitor, j) => {
        if (monitor.player) {
          this.$el.querySelector(`#monitor-${i}-${j}`).pause()
        }
      })
    },
    monitorSwiperChanged ($swiper) {
      const index = $swiper ? $swiper.activeIndex : 0
      const lastIndex = this.monitorList.length - 1
      const prevIndex = index === 0 ? lastIndex : index - 1
      const nextIndex = index === lastIndex ? 0 : index + 1
      this.pauseMonitorGroup(prevIndex)
      setTimeout(() => {
        this.playMonitorGroup(nextIndex)
      }, Math.max(MONITOR_SLIDE_INTERVAL - 10000, 0))
    },
    getChartInfo (code) {
      if (this.chartInfo) {
        return this.chartInfo.find((item) => item.typeCode === code)
      } else {
        return {}
      }
    },
    orgClick (org) {
      console.log(org)
      this.$router.push('org')
    },
    goOrgPage (area, num) {
      console.log(area)
      localStorage.orgInfo = JSON.stringify(this.orgInfo[area])

      this.$router.push({
        name: 'site',
        query: {
          city: num
        }
      })
    },
    loadHls ($video, hlsSrc) {
      const hlsPlayer = new Hls({
        maxBufferSize: 1000 * 1000
      })
      hlsPlayer.loadSource(hlsSrc)
      hlsPlayer.attachMedia($video)
      hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
        console.error(data)
      })
      return hlsPlayer
    },
    openMonitorModal (hlsSrc) {
      this.hlsModalSrc = hlsSrc
      this.monitorShow = true
    },
    monitorOpen () {
      if (this.player2) {
        this.player2.destroy()
        this.player2 = null
      }
      this.$nextTick(() => {
        this.$videoModal = document.querySelector('#monitor-modal')
        this.player2 = this.loadHls(this.$videoModal, this.hlsModalSrc)
        this.player2.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$videoModal.play()
        })
      })
    },
    monitorClose () {
      this.$videoModal.pause()
    },
    startTimer () {
      if (!this.timer) {
        this.timer = setInterval(() => {
          const now = moment()
          const datetime = now.format('YYYY-MM-DD HH:mm')
          const weekday = `星期${
            ['一', '二', '三', '四', '五', '六', '日'][now.isoWeekday() - 1]
          }`
          this.currentTime = `${datetime} ${weekday}`
          this.monitorTime = now.format('YYYY-MM-DD HH:mm')
        }, 1000)
      }
    },
    async getBiFirstScreenType () {
      try {
        const formData = new FormData()
        formData.append('codeTypeId', 10087)
        const { data: res } = await this.$http.post('/comn/codeValue/list', formData)
        for (const row of res.data.rows) {
          this.biFirstScreenType[row.codeValue] = row.nameCn;
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  computed: {
    swiperOption1 () {
      return {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000
        }
      }
    },
    getYesterday () {
      return moment().add('days', -1).format('YYYY-MM-DD')
    },
    monitorSwiperOpts () {
      return {
        autoplay: {
          delay: MONITOR_SLIDE_INTERVAL
        },
        allowTouchMove: false
      }
    }
  },
  beforeDestroy () {
    if (!this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    // this.player1.destroy()
    this.monitorList.forEach((group) => {
      group.forEach((monitor) => {
        if (monitor.player) {
          monitor.player.destroy()
        }
      })
    })
    if (this.player2) {
      this.player2.destroy()
    }
  }
}
</script>
<style lang="scss" scope>
.home {
  width: 1920px;
  height: 1080px;
  background: url("../assets/home/bg.jpg");
  * {
    color: #fff;
  }
  .header {
    width: 100%;
    height: 116px;
    background: url("../assets/home/logokuang.png") no-repeat;
    background-position: center bottom;
    display: flex;
    > div {
      width: 33.33%;
    }
    .notice {
      display: flex;
      align-items: flex-end;
      padding: 0 0 10px 24px;
      box-sizing: border-box;
      font-weight: bold;
      color: #36c4ff;
      font-size: 18px;
      .notice-inner {
        width: 440px;
        overflow: hidden;
        text-align: left;
        .marquee-container {
          display: inline-block;
          span {
            display: inline-block;
            white-space: nowrap;
            animation: 4s linear 0s infinite normal notice-marquee;
          }
        }
      }
    }
    .logo img {
      margin: 20px auto;
    }
    .datetime {
      text-align: right;
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      line-height: 116px;
      padding-right: 24px;
      box-sizing: border-box;
    }
  }
  .main {
    padding: 0 24px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    height: calc(100% - 116px);
    .main-left {
      width: 1410px;
      display: inline-block;
      .main-left-top {
        display: flex;
        .main-left-top-left {
          width: 440px;
          .chart-act {
            height: 205px;
            .block-content {
              display: flex;
              overflow: hidden;
              .chart-container {
                height: 100%;
                flex: 1;
                #highchart-act {
                  width: 100%;
                  height: 100%;
                }
              }
              .act-sort {
                padding: 0 15px;
                overflow: hidden;
                width: 190px;
                box-sizing: border-box;
                // margin-top: -35px;
                .act-sort-title {
                  font-size: 12px;
                  text-align: left;
                  line-height: 20px;
                  color: #ffffff;
                }
                ul {
                  padding-left: 25px;
                  li {
                    font-size: 12px;
                    line-height: 20px;
                    display: flex;
                    justify-content: space-between;
                  }
                }
              }
            }
          }
          .chart-monit {
            position: relative;
            margin-top: 10px;
            height: 295px;
            .block-content {
              padding-bottom: 0;
              .screenshots {
                display: flex;
                flex-wrap: wrap;
                .shot {
                  width: calc(50% - 5px);
                  margin-right: 10px;
                  margin-bottom: 10px;
                  position: relative;
                  &:nth-child(2n) {
                    margin-right: 0;
                  }
                  video {
                    width: 100%;
                    height: auto;
                  }
                  .address {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                  }
                  .area {
                    position: absolute;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    font-size: 14px;
                    font-weight: bold;
                    text-align: center;
                    background-color: rgb(0, 90, 255, 0.5);
                    bottom: 0;
                  }
                }
              }
            }
          }
          .chart-specialist {
            margin-top: 10px;
            height: 188px;
            background: rgba(0, 90, 255, 0.3)
              url(../assets/home/specialist_bg.png) no-repeat;
            ul {
              display: flex;
              justify-content: space-between;
              li {
                display: flex;
                //justify-content: center;
                align-items: center;
                //flex-direction: column;
                width: 48%;
                .avatar {
                  min-width: 100px;
                  height: 120px;
                  position: relative;
                  margin-top: 5px;
                  overflow: hidden;
                  img {
                    width: 100px;
                    height: 120px;
                    object-fit: cover;
                  }
                  div {
                    position: absolute;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: rgba(0, 0, 0, 0.4);
                    font-size: 15px;
                    bottom: 0;
                  }
                }
                .dscp {
                  font-size: 12px;
                  line-height: 20px;
                  text-align: left;
                  height: 120px;
                  margin-left: 10px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 6;
                  -webkit-box-orient: vertical;
                }
              }
            }
          }
        }
        .main-left-top-right {
          padding: 0 20px;
          flex: 1;
          position: relative;
          background: url(../assets/home/map.png) no-repeat;
          background-position: left 10px top;
          position: relative;
          .overview {
            position: absolute;
            top: 0;
            width: calc(100% - 40px);
            background-color: rgba(21, 62, 168, 0.2);
            h4 {
              text-align: left;
              font-size: 16px;
              font-weight: bold;
              padding: 5px 10px;
              margin: 0;
            }
            .nums {
              ul {
                display: flex;
                padding: 0 50px;
                li {
                  width: 25%;
                  h2 {
                    font-size: 50px;
                    margin: 0;
                    line-height: 80px;
                  }
                  &:first-child h2 {
                    color: #f9f404;
                  }
                  &:nth-child(2) h2 {
                    // color: #4ee699;
                    color: #f9f404;
                  }
                  &:nth-child(3) h2 {
                    // color: #c955f4;
                    color: #f9f404;
                  }
                  &:nth-child(4) h2 {
                    // color: #0696ef;
                    color: #f9f404;
                  }
                }
              }
            }
          }
          .map-container {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            .area {
              position: absolute;
              cursor: pointer;
              &.sichuan {
                background: url(../assets/home/sichuanwxz.png) no-repeat;
                width: 235px;
                height: 170px;
                top: 312px;
                left: 360px;
              }
              &.chongqing {
                background: url(../assets/home/chongqingwxz.png) no-repeat;
                width: 104px;
                height: 95px;
                top: 352px;
                left: 524px;
              }
              &.shanghai {
                background: url(../assets/home/shanghaiwxz.png) no-repeat;
                width: 40px;
                height: 46px;
                top: 340px;
                left: 826px;
                &::after {
                  content: "";
                  display: block;
                  position: absolute;
                  background: url(../assets/home/star.png) no-repeat;
                  width: 15px;
                  height: 15px;
                  left: 12px;
                  top: 15px;
                  z-index: 9;
                }
              }
              &.active {
                &.sichuan {
                  background-image: url(../assets/home/sichuan.png);
                }
                &.chongqing {
                  background-image: url(../assets/home/chongqing.png);
                }
                &.shanghai {
                  background-image: url(../assets/home/shanghai.png);
                }
              }
              .holoes {
                .holo {
                  position: absolute;
                  // background-color: rgba(249, 248, 194, .5);
                  background: radial-gradient(
                    rgba(249, 248, 194, 0),
                    rgba(249, 248, 194, 0.5)
                  );
                  width: 150px;
                  height: 150px;
                  top: -55px;
                  left: -55px;
                  border-radius: 50%;
                  animation: 4s linear 0s infinite normal holo-radiation;
                  transition: scale(0);
                  &:nth-child(2) {
                    animation-delay: 1s;
                  }
                  &:nth-child(3) {
                    animation-delay: 2s;
                  }
                }
              }
            }
            .light {
              position: absolute;
              cursor: pointer;
              &.sichuan {
                background-image: url(../assets/home/light_sichuan.png);
                width: 203px;
                height: 198px;
                top: 178px;
                left: 310px;
              }
              &.chongqing {
                background-image: url(../assets/home/light_chongqing.png);
                width: 168px;
                height: 93px;
                left: 525px;
                top: 312px;
              }
              &.shanghai {
                background-image: url(../assets/home/light_shanghai.png);
                width: 41px;
                height: 172px;
                top: 190px;
                left: 820px;
              }
            }
            .info-box {
              position: absolute;
              width: 170px;
              height: 88px;
              // border: 2px solid #f9f8c2;
              background: url(../assets/home/area_card_bg.png);
              display: flex;
              flex-direction: column;
              justify-content: center;
              cursor: pointer;
              h3 {
                margin: 0;
                font-size: bold;
                font-size: 26px;
              }
              span {
                font-size: 18px;
                font-weight: bold;
              }
              &.sichuan {
                top: 167px;
                left: 312px;
              }
              &.chongqing {
                top: 224px;
                left: 526px;
              }
              &.shanghai {
                top: 165px;
                left: 755px;
              }
            }
          }
          .chart-checkin,
          .chart-checkin-top {
            position: absolute;
            bottom: 0;
            left: 20px;
            width: calc(50% - 10px);
            height: 150px;
            background-color: transparent;
            #highchart-checkin,
            #highchart-checkin-top {
              width: 100%;
              height: 100%;
            }
          }
          .chart-checkin-top {
            left: auto;
            right: 10px;
          }
        }
      }
      .main-left-bottom {
        height: 230px;
        margin-top: 10px;
        display: flex;
        > div {
          height: 100%;
          .block {
            height: 100%;
          }
          .chart-meal {
            width: 836px;
            .block-content {
              display: flex;
              #highchart-meal {
                height: 100%;
                width: 50%;
              }
              #highchart-meal-bar {
                height: 100%;
                width: 50%;
              }
            }
          }
          .chart-gender {
            width: 266px;
            #highchart-gender {
              height: 100%;
            }
          }
          .chart-age {
            #highchart-age {
              height: 100%;
            }
          }
        }
        .main-left-bottom-center {
          margin-left: 10px;
        }
        .main-left-bottom-right {
          flex: 1;
          margin-left: 10px;
        }
      }
    }
    .main-righthoho {
      // flex: 1;
      display: inline-block;
      width: 500px;
      // display: flex;
      flex-direction: column;
      // padding-left: 10px;
      .chart-checkin {
        height: calc(100% - 496px);
        .block-content {
          height: calc(50% - 35px);
          #highchart-checkin,
          #highchart-checkin-top {
            height: 100%;
          }
        }
      }
      .chart-disease {
        height: 230px;
        margin-top: 10px;
        #highchart-disease {
          height: 100%;
        }
        #highchart-disease-bar {
          height: 100%;
        }
      }
      .chart-nurse {
        margin-top: 10px;
        height: 230px;
        #highchart-nurse {
          height: 100%;
        }
      }
    }
  }

  .block {
    background-color: rgb(0, 90, 255, 0.3);
    display: flex;
    flex-direction: column;
    .block-header {
      display: flex;
      font-size: 14px;
      font-weight: bold;
      justify-content: space-between;
      padding: 0 10px;
      height: 35px;
      line-height: 35px;
    }
    .block-content {
      padding: 0 10px 10px 10px;
      flex: 1;
    }
  }

  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
}
.fourimg{
  display: flex;
  flex-wrap: wrap;
  .fourItem{
    width: 48%;
    height: 48%;
    position: relative;
    .itemPic{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .itemP{
      padding: 0;
      margin: 0;
      width: 100%;
      height: 30px;
      position: absolute;
      bottom: 0;
      left: 0;
      color: #fff;
      text-align: center;
      line-height: 30px;
      background: rgb(54 196 255 / 50%)
    }
  }
}
@keyframes holo-radiation {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
@keyframes notice-marquee {
  0% {
    transform: translateX(440px);
  }
  100% {
    transform: translateX(-100%);
  }
}
#monitor-modal {
  width: 100%;
  height: auto;
}
.tipsName {
  position: absolute;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  font-size: 15px;
  bottom: 0px;
}
</style>
